import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import LicenseGroup, { licenseOption } from "./LicenseGroup";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const RecurrentPaymentError = () => {
  const { profile, baseUrl } = useStore();

  return (
    <div className={cx("licenses-block", "free-access-block", "color-red")}>
      <LicenseGroup
        href={`https://billing.${baseUrl}/addinvoice?option=1&utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`}
        onClick={() => sendNavigationMetric("RECURRENT_PAYMENT_ERROR")}
        refreshDisabled={profile.refreshLicenses.disabled}
        refreshLoading={profile.refreshLicenses.loading}
        refreshError={profile.refreshLicenses.error}
        refreshAction={profile.refreshLicenses.refresh}
        after={
          <span className={cx("free-access-text", "recurrent-error-text")}>
            {strings.profile_recurrentPaymentFailed}
          </span>
        }
        option={licenseOption.FREE_ACCESS}
      >
        {strings.profile_freeAccess}
      </LicenseGroup>
    </div>
  );
};

export default observer(RecurrentPaymentError);
